module.exports = __webpack_public_path__ + "media/images/rapide-ac216c1a58e2bb63a94f21bf35513646.svg";